import { of, BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map, switchMap, filter, tap } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';
import { ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';

function collectRoutesData(route) {
    const dataSubjects = [];
    if (route instanceof ActivatedRouteSnapshot) {
        let r = route;
        do {
            dataSubjects.unshift(of(r.data));
            r = r.parent;
        } while (r);
    }
    else if (route instanceof ActivatedRoute) {
        let r = route;
        do {
            dataSubjects.unshift(r.data);
            r = r.parent;
        } while (r);
    }
    return dataSubjects;
}

class RouteSubject {
    constructor() {
        this.subject = new BehaviorSubject(undefined);
    }
    /**
     * Subscribe to observer data changes
     *
     * @param func
     * @returns
     */
    subscribe(func) {
        return this.subject.subscribe(func);
    }
    /**
     * Observe changes from passed observable (Service)
     *
     * @param observable
     * @returns
     */
    observe(observable) {
        this._targetObservable = observable;
        this._load();
        return of(this);
    }
    /**
     * Provide value to subscriber
     *
     * @param val
     * @returns
     */
    next(val) {
        this.subject.next(val);
        return of(this);
    }
    /**
     * Destroy observer
     */
    destroy() {
        this.subject.complete();
    }
    reload() {
        this._load();
    }
    _load() {
        this._targetObservable.subscribe((val) => {
            this.next(val);
        });
    }
}

class RouteObserver extends Observable {
    constructor(route, name) {
        super();
        this._loaded$ = new BehaviorSubject(false);
        const routesData = collectRoutesData(route);
        const stream = combineLatest(routesData)
            .pipe(map((data) => {
            return data.reduce((acc, routeData) => {
                return Object.assign(Object.assign({}, acc), routeData);
            }, {});
        }, {}), switchMap((routeData) => {
            const target = routeData[name];
            if (target instanceof RouteSubject && target.subject) {
                this._routeSubject = target;
                this._routeSubject$ = target.subject;
                return target.subject;
            }
            return of(null);
        }), filter((item) => {
            return item !== undefined;
        }), map((item) => {
            return cloneDeep(item);
        }), tap(() => {
            this._loaded$.next(true);
        }));
        this._subscribe = ((subscriber) => stream.subscribe(subscriber));
    }
    get loaded() {
        return this._loaded$.getValue();
    }
    get loaded$() {
        return this._loaded$.asObservable();
    }
    reload() {
        this._loaded$.next(false);
        this._routeSubject.reload();
    }
    next(value) {
        if (this._routeSubject$) {
            this._routeSubject$.next(value);
        }
    }
}

function controlContainerFactory(ngForm) {
    return ngForm;
}

function getPathToRouteParent(route) {
    // let stepsBack = 1;
    // let route = this._route.parent;
    // we are looking for parent route to navigate from current dialog
    // but we have to skip routes like loadChildren or redirectTo
    // because it does not make sence to do navigation to them
    // while (route.routeConfig && (route.routeConfig.redirectTo || route.routeConfig.path === '') && route.parent) {
    //   stepsBack++;
    //   if (route.routeConfig.path === '' && route.parent?.routeConfig.loadChildren && route.parent?.parent) {
    //     route = route.parent.parent
    //   } else {
    //     route = route.parent;
    //   }
    // }
    const stepsBack = (route.routeConfig.path.match(/\//g) || []).length + 1;
    // make relative navigation path like '../../../';
    return Array
        .from(Array(stepsBack), () => '../')
        .join('');
}

/**
 * Generated bundle index. Do not edit.
 */

export { RouteObserver, RouteSubject, controlContainerFactory, getPathToRouteParent };
